// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1skeJ","label":"Category_label__1iyFY","content":"Category_content__2ux9Q","header":"Category_header__1fiY8","location":"Category_location__3eAoX"};